export const Employee_Salary = "Employee Salary";
export const Employee_Expense = "Employee Expense";
export const Vendor_Expense = "Vendor Expense";
export const Vendor_Expense_Admin = "Vendor Expense Admin";
export const Petty_Expense = "Petty Expense";

export const category = "category";
export const company = "company";